import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import { get } from 'lodash';
import { getNonPassiveHandlerOptions } from 'utils/detectPassiveEvents';

export default class LevelItem extends PureComponent {
  static propTypes = {
    category: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    itemLink: PropTypes.string.isRequired,
    toIdsRoot: PropTypes.array.isRequired,
    isCategoryExpanded: PropTypes.bool.isRequired,
    isLeaf: PropTypes.bool.isRequired,
    levelIdx: PropTypes.any,
    onTouchStart: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onActivate: PropTypes.func.isRequired,
    onDeactivate: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.link.addEventListener('touchstart', this.onTouchStart, getNonPassiveHandlerOptions());
  }

  componentWillUnmount() {
    this.link.removeEventListener('touchstart', this.onTouchStart);
  }

  onActivate = (e) => this.props.onActivate(e, this.getToIds(), this.props.category.id);

  onTouchStart = (e) => {
    if (this.props.isCategoryExpanded || this.props.isLeaf) {
      this.props.onTouchStart(e, this.getToIds(), this.props.category.id);
      this.props.onDeactivate(e);
    } else {
      e.preventDefault();
      this.props.onActivate(e, this.getToIds(), this.props.category.id);
    }
  };

  onClick = (e) => this.props.onClick(
    e,
    this.props.category.id,
    this.props.levelIdx,
    get(this.props, 'category.name'),
  );

  getToIds = () => {
    const { category, toIdsRoot, isLeaf } = this.props;
    return isLeaf ? toIdsRoot : toIdsRoot.concat(category.id);
  };

  render() {
    const { category, isCategoryExpanded, onDeactivate, isLeaf, itemLink } = this.props;

    const itemClass = classNames('level-item', isLeaf ? 'leaf' : 'has-children', { selected: isCategoryExpanded });

    return (
      <li
        className={itemClass}
        ref={ref => { this.link = ref; }}
      >
        <Link
          to={itemLink}
          className="level-item-link"
          onFocus={this.onActivate}
          onMouseOver={this.onActivate}
          onBlur={onDeactivate}
          onMouseOut={onDeactivate}
          onTouchStart={this.onTouchStart}
          onClick={this.onClick}
        >
          {category.name}
        </Link>
      </li>
    );
  }
}
